<script setup lang="ts">
    import { computed } from 'vue'
    import { ErrorData, getViolationsFeedback } from '@/js/utils'

    const emit = defineEmits(['update:modelValue'])

    export interface Props {
        modelValue: string
        label?: string
        hint?: string
        placeholder?: string
        dataTest?: string
        error?: ErrorData
        violationFields?: string[]
        isLoading?: boolean
        disabled?: boolean
    }

    const props = withDefaults(defineProps<Props>(), {
        label: '',
        hint: '',
        placeholder: '',
        violationFields: () => [] as string[],
        dataTest: '',
        error: () => {
            return {} as ErrorData
        },
        isLoading: false,
        disabled: false
    })

    const value = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    })

    const errorMessages = computed(() => {
        return props.error ? getViolationsFeedback(props.violationFields, props.error) : ''
    })
</script>

<template>
    <v-text-field
        v-model="value"
        :disabled="isLoading || disabled"
        minlength="0"
        maxlength="3500"
        :label="label"
        :placeholder="placeholder"
        :data-test="dataTest"
        trim
        rounded="0"
        variant="plain"
        density="comfortable"
        class="px-3"
        :hint="hint"
        :persistent-hint="!!hint"
        :hide-details="!hint && !errorMessages?.length"
        :error-messages="errorMessages"
        :error="!!errorMessages?.length"
    />
</template>

<style scoped></style>
